import { attractionQueryKeys as e } from "./useAttractionQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { attractionApi as n } from "@maat/api-main";
//#region src/attractions/useAttractionsQuery.ts
var r = (r, i, a) => t({
	queryKey: e.byArea(r ?? "", i.latitude, i.longitude, a),
	queryFn: () => n.getAttractions({
		areaId: r,
		lat: i.latitude,
		lng: i.longitude,
		category: a
	}),
	enabled: !!r
});
//#endregion
export { r as useAttractionsQuery };
